import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Never let the browser restore an old scroll position (e.g. jumping to the bottom on reload).
if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
